import { gql } from '@apollo/client';

export const CREATE_ROLE_MUTATION = gql`
  mutation createRole($name: String!, $permissions: [PermissionInputObject!]!, $filteringRuleGroupIds: [Int!]) {
  createRole(name: $name, permissions: $permissions, filteringRuleGroupIds: $filteringRuleGroupIds) {
    role {
      id
      name
      permissions {
        id
        name
        resourceName
      }
      filteringRuleGroups {
        id
        name
        deletedAt
      }
    }
  }
}
`;

export const EDIT_ROLE_MUTATION = gql`
 mutation editRole($id: Int!, $name: String, $permissions: [PermissionInputObject!], $filteringRuleGroupIds: [Int!]) {
  editRole(id: $id, name: $name, permissions: $permissions, filteringRuleGroupIds: $filteringRuleGroupIds) {
    role {
      id
      name
      permissions {
        id
        name
        resourceName
      }
      filteringRuleGroups {
        id
        name
        deletedAt
      }        
    }
  }
 }
`;
